import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Pencil, Ellipsis, Plus, Trash2 } from 'lucide-react';
import { X } from 'lucide-react';

const DynamicTable = (props) => {
    const [tables, setTables] = useState({
        tab: [

        ],
        columns: ['Action', 'Task'], // Initial columns for the first table
    });
    const [submittedData, setSubmittedData] = useState([]);
    const popupRef = useRef(null);
    useEffect(() => { console.log({ tables }) }, [tables]);

    useEffect(() => {
        const dataToSubmit = tables.tab.map((table) => ({
            title: table.tab.title, // Keep table title
            rows: table.tab.rows.map((row) => {
                // Map row values to column names
                return tables.columns.reduce((acc, column, index) => {
                    acc[column] = row[index];
                    return acc;
                }, {});
            }),
        }));
        props.getData(dataToSubmit);
        console.log({ dataToSubmit })
    }, [tables]);
    const breakDown = useMemo(() => {
        return props.breakDown
    }, [JSON.stringify(props.breakDown)]);
    useEffect(() => {
        if (breakDown.length > 0) {
            const newColumns = [...new Set(breakDown.flatMap(table => Object.keys(table.rows[0])))];
            const newTables = {
                tab: breakDown.map(table => ({
                    tab: {
                        rows: table.rows.map(row => newColumns.map(column => row[column] || '')),
                        title: table.title,
                    },
                })),
                columns: newColumns,
            };
            setTables(newTables);
        }
    }, [breakDown]);

    // Function to add a New Area
    const addTable = (e) => {
        e.preventDefault();
        setTables({
            ...tables,
            tab: [
                ...tables.tab,
                {
                    tab: {
                        rows: [Array.from({ length: tables.columns.length }, () => '')], // Initial table with one empty row
                        title: 'New Area',
                    },
                },
            ],
        });
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                popupRef.current.classList.add('d-none');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Function to add a new row to a specific table
    const addRow = (tableIndex) => {
        const newTables = { ...tables };
        newTables.tab[tableIndex].tab.rows.push(Array.from({ length: tables.columns.length }, () => ''));
        setTables(newTables);
    };

    // Function to add a new column to all tables
    const addCol = (tabName) => {
        if (tables.columns.includes(tabName)) {
            console.log(`Column '${tabName}' already exists.`);
            const index = tables.columns.indexOf(tabName);
            const tempColumns = tables.columns.filter((item) => item !== tabName);
            const newTables = {
                ...tables,
                columns: tempColumns,
            };
            setTables(newTables);
            newTables.tab.forEach((table) => {
                table.tab.rows.forEach((row) => {
                    row.splice(index, 1); // Remove column from each row
                });
            });
            setTables(newTables);
        } else {
            const newTables = {
                ...tables,
                columns: [...tables.columns, tabName],
            };
            newTables.tab.forEach((table) => {
                table.tab.rows.forEach((row) => {
                    row.push(''); // Add empty cell for new column in each row
                });
            });
            setTables(newTables);
        }
    };

    // Function to handle changes in table cell inputs
    const handleInputChange = (value, tableIndex, rowIndex, columnIndex) => {
        const newTables = { ...tables };
        newTables.tab[tableIndex].tab.rows[rowIndex][columnIndex] = value;
        setTables(newTables);
    };

    // Function to delete a table
    const deleteTable = (tableIndex) => {
        const newTables = { ...tables };
        newTables.tab.splice(tableIndex, 1); // Remove 1 element at tableIndex
        setTables(newTables);
    };

    // Function to handle form submission
    const handleSubmit = () => {
        const dataToSubmit = tables.tab.map((table) => ({
            title: table.tab.title, // Keep table title
            rows: table.tab.rows.map((row) => {
                // Map row values to column names
                return tables.columns.reduce((acc, column, index) => {
                    acc[column] = row[index];
                    return acc;
                }, {});
            }),
        }));
        setSubmittedData(dataToSubmit);
        console.log('Submitted data:', dataToSubmit);
        // Here you can send dataToSubmit to your backend or perform further actions
    };

    // Function to handle title change
    const handleTitleChange = (e, tableIndex) => {
        const newTables = { ...tables };
        newTables.tab[tableIndex].tab.title = e.target.value;
        setTables(newTables);
    };

    const openPopup = () => {
        popupRef.current.classList.remove('d-none');
    };
    const closePopup = () => {
        popupRef.current.classList.add('d-none');
    };

    return (
        <div className="container custom-scroll">
            {/* Popup div for adding columns */}
            <div ref={popupRef} style={{ width: '25rem' }} className="position-absolute container d-none">
                <div className="card rounded">
                    <div className='d-flex justify-content-end align-items-center'>
                        <X size='18px' onClick={closePopup} style={{ cursor: 'pointer' }} />
                    </div>
                    <div className="row">
                        {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Weekly', 'Monthly', 'Yearly', 'Half-yearly', 'Quarterly'].map((day) => (
                            <div key={day} className="col-lg-4 col-md-4 col-sm-6">
                                <p className={`${tables.columns.includes(day) ? 'selected' : ''}`} onClick={() => addCol(day)} style={{ cursor: 'pointer' }}>
                                    {day}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {tables.tab.map((table, tableIndex) => (
                <div key={tableIndex} className="mb-2 table-div">
                    <div className='d-flex gap-2 align-items-center'>
                        <div>
                            <Ellipsis color='#ff176b' className="mb-0 dropdown-toggle" data-bs-toggle="dropdown"
                                aria-expanded="false" />
                            <ul className="dropdown-menu dropdown-menu-end mt-2" aria-labelledby="dropdownMenu2">
                                <li><button className="dropdown-item" type="button" onClick={() => deleteTable(tableIndex)}>
                                    Remove Area
                                </button></li>
                            </ul>
                        </div>
                        <div className='w-75 mt-2'>
                            <input type="text" className="form-control mb-2" value={table.tab.title} onChange={(e) => handleTitleChange(e, tableIndex)} />
                        </div>
                    </div>
                    <table className="table table-responsive">
                        <thead>
                            <tr className='tr-color'>
                                {tables.columns.map((column, columnIndex) => (
                                    <th className='th-style' key={columnIndex} scope="col">
                                        {column}
                                    </th>
                                ))}
                                <th onClick={() => openPopup()} style={{ width: "10%", textAlign: 'center' }}><Plus size={"18px"} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {table.tab.rows.map((row, rowIndex) => (
                                <tr key={rowIndex} className='tr-color'>
                                    {row.map((cell, cellIndex) => (
                                        <td key={cellIndex} style={{ textAlign: "-webkit-center" }}>
                                            {cellIndex === 0 ? (
                                                <Trash2 color='#ff176b' size="16px" strokeWidth="1" style={{ marginTop: "10px" }} />
                                            ) : (
                                                <input
                                                    type={`${cellIndex >= 2 ? 'checkbox' : 'text'}`}
                                                    className={`${cellIndex >= 2}`} style={{ outline: "none", padding: "5px", textAlign: "center", color: "#afafaf" }}
                                                    checked={cellIndex >= 2 ? Boolean(cell) : undefined} placeholder='Task'
                                                    value={cellIndex < 2 ? cell : undefined}
                                                    onChange={(e) =>
                                                        handleInputChange(
                                                            cellIndex >= 2 ? e.target.checked : e.target.value,
                                                            tableIndex,
                                                            rowIndex,
                                                            cellIndex
                                                        )
                                                    }
                                                />
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            <tr>
                                <td colSpan={tables.columns.length + 1}>
                                    <input type='text' className="mb-2" placeholder='+Add Task' onClick={() => addRow(tableIndex)} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ))}
            <button className="btn add-button" onClick={addTable}>
                Add Area
            </button>
        </div>
    );
};

export default DynamicTable;
